// После АБ теста - удалить, а также ABAnimationFortune и ABAnimationAva, а также npm react-confetti

import { useHandleResize, useClickOutside } from "@hook";
import { clearParamWithoutRerender, getSqlServerGuidHash, sendMetric, getWhatId, getAbTestMetrika } from "@utils";

import { inject, observer } from "mobx-react";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import modal_close_2 from "./img/modal_close_2.svg";
import modal_close_2_mobile from "./img/modal_close_2_mobile.svg";

import AIModal from "../../components/Modal/AIModal";
import AvaWheelModal from "../../components/Modal/AvaWheelModal";

import AvaWheelModalWheel from "../../components/Modal/AvaWheelModalWheel";
import CPCModal from "../../components/Modal/CPCModal";
import FortuneModal from "../../components/Modal/FortuneModal";
import GhostModal from "../../components/Modal/GhostModal";
import OfferModal from "../../components/Modal/OfferModal";
import PromoModal from "../../components/Modal/PromoModal";

import WheelOfFortune from "../../components/Modal/WheelOfFortune";

import "./style.scss";
import Face from "../../components/Modal/Face";

const { VITE_WHAT_ID } = import.meta.env;

const types = ["ava-wheel", "fortune", "face", "koleso", "fortuneNew"];

const Modal = inject("mainStore")(
    observer(({ mainStore }) => {
        const modal = mainStore.getMainStore("modal");
        const abTest = mainStore.getMainStore("abTest");
        const abTestMetika = mainStore.getMainStore("abTestMetika");
        const settingLego = mainStore.getMainStore("settingLego");

        const nodeRef = useRef();

        const { type, offerItem } = modal;
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const location = useLocation();
        const isMobile = useHandleResize();
        const isAbTestMetrika = getAbTestMetrika(abTest, offerItem?._id);

        useClickOutside(type, nodeRef, types.includes(type) ? () => {} : () => handleCloseModal());

        const itType = (offerItem && offerItem.offerOptions?.find((f) => !ignoredTypes.includes(f))) || false;

        const Specified = type ? modals[type] : false;

        useEffect(() => {
            let body = document.body;
            if (body && Specified) {
                body.style.overflow = "hidden";
                body.style["touch-action"] = "none";
                body.style["-webkit-overflow-scrolling"] = "none";
                body.style["overscroll-behavior"] = "none";
                body.style.width = "100%";
            } else {
                body.style = {};
            }
        }, [Specified, isMobile]); // isMobile чтобы срезать стили для блокировки скрола на мобильном устройстве

        const handleCloseModal = () => {
            clearParamWithoutRerender(["id", "code", "noym"]);
            mainStore.setMainStore("modal", false);
            mainStore.setMainStore("promoIdCity", false);
            mainStore.setMainStore("promoIdRegion", false);
            mainStore.setMainStore("promoIdMetro", false);

            if (type === "offer") {
                if (!localStorage.getItem("first_click_offer_close")) {
                    sendMetric(`first_click_offer_close`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offerItem?._id,
                        params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                        params4: offerItem?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                    localStorage.setItem("first_click_offer_close", true);
                }
                sendMetric(`click_offer_close`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: offerItem?._id,
                    params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                    params4: offerItem?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: what_id,
                });
            }

            if (type === "promo" || type === "ghost") {
                sendMetric(`click_offer_accepted_close`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: offerItem?._id,
                    params3: getSqlServerGuidHash(offerItem.code, offerItem.vendor?._id),
                    params4: offerItem?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: what_id,
                });
            }
        };

        // не показываем модалку если это мобильный телефон и есть айдишка на открытие офера напрямую
        if (isMobile && type !== "cpc") {
            const searchParams = new URLSearchParams(location.search);
            const id = searchParams.get("id");
            if (id) return;
        }
        // не показываем модалку если это мобильный телефон и есть айдишка на открытие офера напрямую

        const modalBgColor = settingLego?.bgColor === "palette" ? "var(--color2)" : "var(--color5)";

        return Specified ? (
            <div className={`modal  ${Specified ? "show-modal" : ""} ${type}`} style={{ "--bgColor": modalBgColor }}>
                <div ref={nodeRef} id="modal-container" className={`modal__content ${type} ${itType ? itType : ""}`}>
                    {itType ? <span className={`hit-label ${itType}`}>{"хит"}</span> : null}
                    {type == "ava-wheel" || type == "fortune" || type == "fortuneNew" || type == "koleso" || type === "face" ? null : (
                        <>
                            <img src={modal_close_2} className="modal__content_close cursor" onClick={() => handleCloseModal()} />
                            <img src={modal_close_2_mobile} className="modal__content_close_mobile" onClick={() => handleCloseModal()} />
                        </>
                    )}

                    {Specified ? <Specified modal={modal} /> : null}
                </div>

                {type === "promo" ? (
                    <div className={`promo_button `} onClick={() => handleCloseModal()}>
                        Выбрать больше подарков +
                    </div>
                ) : null}
            </div>
        ) : null;
    }),
);

const modals = {
    offer: OfferModal,
    promo: PromoModal,
    "ava-wheel": AvaWheelModal,
    fortune: FortuneModal,
    ghost: GhostModal,
    cpc: CPCModal,
    fortuneNew: WheelOfFortune,
    koleso: AvaWheelModalWheel,
    ai: AIModal,
    face: Face,
};

const ignoredTypes = ["isEndDate", "redirect"];

export default Modal;
